import { render, staticRenderFns } from "./v-radio-group.vue?vue&type=template&id=3a5bd508&scoped=true&"
import script from "./v-radio-group.vue?vue&type=script&lang=js&"
export * from "./v-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./v-radio-group.vue?vue&type=style&index=0&id=3a5bd508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bd508",
  null
  
)

export default component.exports